import api from "../api";
import qs from "qs";

const serialize = (params) => qs.stringify(params, { arrayFormat: "repeat" });

export function montarUrlIntegracaoDenuncia(identificadorEndpoint) {
  if (!identificadorEndpoint) return "";
  const gateway = (process.env.REACT_APP_GATEWAY || "").replace(/\/$/, "");
  return `${gateway}/api/integracoes/v1/denuncias/${identificadorEndpoint}`;
}

export const integracaoDenunciaService = {
  list(params) {
    return api.get("/admin/integracoes-denuncia", {
      params,
      paramsSerializer: serialize,
    });
  },
  get(codigo) {
    return api.get(`/admin/integracoes-denuncia/${codigo}`);
  },
  create(payload) {
    return api.post("/admin/integracoes-denuncia", payload);
  },
  update(codigo, payload) {
    return api.put(`/admin/integracoes-denuncia/${codigo}`, payload);
  },
  ativar(codigo) {
    return api.put(`/admin/integracoes-denuncia/${codigo}/ativar`);
  },
  desativar(codigo) {
    return api.put(`/admin/integracoes-denuncia/${codigo}/desativar`);
  },
  regenerarChave(codigo) {
    return api.post(`/admin/integracoes-denuncia/${codigo}/regenerar-chave`);
  },
  catalogoCampos() {
    return api.get("/admin/integracoes-denuncia/campos");
  },
  listarCanais(params) {
    return api.get("/admin/integracoes-denuncia/canais", {
      params,
      paramsSerializer: serialize,
    });
  },
  listarGrupos(params) {
    return api.get("/admin/integracoes-denuncia/grupos", {
      params,
      paramsSerializer: serialize,
    });
  },
  listarLogs(codigo, params) {
    return api.get(`/admin/integracoes-denuncia/${codigo}/logs`, {
      params,
      paramsSerializer: serialize,
    });
  },
};
